const rawBase = process.env.CEREBRO_API_BASE_URL || "";

export const API_BASE = rawBase.endsWith("/")
  ? rawBase.slice(0, -1)
  : rawBase;
